// components
import { Content } from './Content';

const ActivateUser = () => {
    return <Content />;
};

export default ActivateUser;
